<div class="back-container" xmlns="http://www.w3.org/1999/html">
  <div>
    @if (step > 2) {
      <button id="abort-warranty" [hidden]="!(isCancelAllowed() || isAbortAllowed()) || isYUCAllowed()"
        (click)="onCancel()"
      class="button button-back">{{'' | i18n: warranty.warrantyStatus === 'Active' ? 'cancel-warranty' : 'abort-warranty' }}</button>
    }
  </div>
  <div>
    @if (step > 2) {
      <button id="save-warranty" [disabled]="!editable  || (!proceedToStep4Eligible()) || isYUCAllowed() || isSpecialRequestAllowed()"
        (click)="saveAndClose()"
      class="button button-Safe">{{'' | i18n: 'save-warranty'}}</button>
    }
  </div>
</div>
<div class="row" style="margin-left: 5%;width: 90%;height: 58px;">
  @if (warranty.isExtended) {
    <h3>{{'' | i18n: 'extend-vehicle-warranty'}}</h3>
  }
  @if (!warranty.isExtended) {
    <h3>{{'' | i18n: 'used-vehicle-warranty'}}</h3>
  }
  <div class="short-summary extended">
    {{warrantyProgress}}
  </div>
</div>
<div class="progress-container">
  <button class="btn_steps" (click)="step = 0" [disabled]="warranty.maxStep < step">{{'' | i18n: 'step-1'}}</button>
  <button class="btn_steps" (click)="stepToOne()" [disabled]="warranty.maxStep < 1">{{'' | i18n: 'step-2'}}</button>
  <button class="btn_steps" (click)="stepToTwo()" [disabled]="warranty.maxStep < 2">{{'' | i18n: 'step-3'}}</button>
  <button class="btn_steps" (click)="stepToThreeFree()"
  [disabled]="warranty.maxStep < 3">{{'' | i18n: 'step-4'}}</button>
  <button class="btn_steps" (click)="step = 4" [disabled]="warranty.maxStep < 4">{{'' | i18n: 'step-5'}}</button>
</div>

<app-accept-modal [warranty]="this.warranty" #modalComponent
  style=" position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
</app-accept-modal>

<app-cancel-modal [warranty]="this.warranty" #cancelComponent
  style=" position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
</app-cancel-modal>

@if (step === 0) {
  <div><!-- SEARCH VIN AND GET CUSTOMER DATA -->
    <div class="step-title-container">{{'' | i18n: 'step-1-title'}}.</div>
    @if (licensePlateToVinToggle && capabilities?.licensePlateToVin) {
      <div class="filter-container-license-plate">
        <div class="filter-item-label">{{'' | i18n: 'license-plate'}}:</div>
        <div class="filter-item-search">
          <input #keywordVin id="licensePlate" type="text" name="keyword" [(ngModel)]="licensePlate"
            (keydown.enter)="searchLicensePlate()" [disabled]="!editable || isYUCAllowed()" autofocus>
          </div>
          <div class="filter-item-search-btn">
            <button id="searchLicensePlate" [disabled]="!editable || isYUCAllowed()" (click)="searchLicensePlate()"
              style="margin: 0px 0px 0px -5px !important;"
              class="button search-btn">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
          <div class="filter-item-search-btn">
            <button (click)="clearLicenseFilter()" style="padding-top: 0px;margin-left: -12px" class="button search-btn">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      }
      @if (licensePlateToVinToggle === false || capabilities?.licensePlateToVin === false || licensePlateError !== '' || vin) {
        <div class="filter-container"
          >
          @if ( licensePlateToVinToggle=== false || capabilities?.licensePlateToVin=== false ||
            licensePlateError !=='') {
            <section>
              <div class="filter-item-label">{{'' | i18n: 'chassis'}}:</div>
              <div class="filter-item-search">
                <input id="keywordVIN" type="text" name="keyword" class="text-uppercase" [(ngModel)]="vin"
                  placeholder="e. g. WBAJA11060BH85330" (keydown.enter)="searchVin()" [disabled]="!editable || isYUCAllowed()" autofocus>
                </div>
                <div class="filter-item-search-btn">
                  <button id="search" [disabled]="!editable || isYUCAllowed()" (click)="searchVin()" style="margin: 0px 0px 0px -5px !important;"
                    class="button search-btn">
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="filter-item-search-btn">
                  <button (click)="clearFilter()" style="padding-top: 0px;margin-left: -12px" class="button search-btn">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </section>
            }
            <br>
            </div>
          }
          <div class="error-text">{{'' | i18n: vinError }}</div>
          <div class="error-text">{{'' | i18n: licensePlateError }}</div>
          <div class="col-lg-12 mt-4" style="text-align: center;margin-left: -63px;">
          </div>
          @if (warranty.vehicle) {
            <div class="form-row-container" style="margin-left: 5%;width: 90%;height: 195px;">
              <h2>{{'' | i18n: 'vehicle-details'}}.</h2>
              <div class="table-header2">
                <div class="table-header-item-chassis">{{'' | i18n: 'chassis'}}</div>
                <div class="table-header-item-chassis">{{'' | i18n: 'licence'}}</div>
                <div class="table-header-item-chassis">{{'' | i18n: 'brand'}}</div>
                <div class="table-header-item-chassis">{{'' | i18n: 'model'}}</div>
                <div class="table-header-item-chassis">{{'' | i18n: 'model-desc'}}</div>
                <div class="table-header-item-chassis">{{'' | i18n: 'date-of-registration'}}</div>
                <div class="table-header-item-chassis">{{'' | i18n: 'colour'}}</div>
                @if (!warranty.owner) {
                  <div class="table-header-item-chassis">{{'' | i18n: 'action'}}</div>
                }
              </div>
              <div class="table-list2">
                <div class="table-list-item-chassis-2 data-table">{{warranty.vehicle.vin}}</div>
                <div class="table-list-item-chassis-2"><label><input type="text"
                  [disabled]="!editable || (licensePlateToVinToggle && warranty.vehicle.isLicencePlateDateFromSource) || isYUCAllowed()"
                [(ngModel)]="warranty.vehicle.licencePlate"></label>
                <div class="error-text-small">{{licenceError}}</div>
              </div>
              <div class="table-list-item-chassis-2 data-table">{{ warranty.vehicle.brand }}</div>
              <div class="table-list-item-chassis-2 data-table">{{ warranty.vehicle.model }}</div>
              <div class="table-list-item-chassis-2 data-table">{{ warranty.vehicle.modelDescription }}</div>
              <div class="table-list-item-chassis-2">
                @if (mileageAndDatesValidationToggle) {
                  <input type="date" aria-invalid="true" max="{{ todayStartOfDay() | date: 'yyyy-MM-dd' }}"
                    [min]="firstRegistrationDateMin"
                    [disabled]="!editable || isYUCAllowed() || (firstRegistrationDateFromSourceToggle || licensePlateToVinToggle) && warranty.vehicle.isFirstRegistrationDateFromSource"
                    [(ngModel)]="warranty.vehicle.dateOfRegistration"/>
                }
                @if (!mileageAndDatesValidationToggle) {
                  <input type="date" aria-invalid="true" max="{{ todayStartOfDay() | date: 'yyyy-MM-dd' }}"
                    [disabled]="!editable || isYUCAllowed() || (firstRegistrationDateFromSourceToggle || licensePlateToVinToggle) && warranty.vehicle.isFirstRegistrationDateFromSource"
                    [(ngModel)]="warranty.vehicle.dateOfRegistration"/>
                }
                <div class="error-text-small">{{'' | i18n:dateOfRegError}}</div>
              </div>
              <div class="table-list-item-chassis-2 data-table">{{ warranty.vehicle.colour }}</div>
              @if (!warranty.owner) {
                <div class="table-list-item-chassis-2">
                  <button id="submit-vehicle" (click)="stepToOne()" class="btn-default"
                    style="width: 126px;">{{'' | i18n: 'select-vehicle'}}<i class="fa fa-chevron-right"
                  aria-hidden="true"></i></button>
                </div>
              }
            </div>
            @if (warranty.owner) {
              <div class="form-row-container" style="width: 100%;margin-top: 30px">
                <h2>{{'' | i18n: 'owner-of-vehicle'}}.</h2>
                <div class="table-header2">
                  <div class="table-header-item-chassis-vehicle">{{'' | i18n: 'company'}}</div>
                  <div class="table-header-item-chassis-vehicle">{{'' | i18n: 'name'}}</div>
                  <div class="table-header-item-chassis-vehicle">{{'' | i18n: 'last-name'}}</div>
                  <div class="table-header-item-chassis-vehicle">{{'' | i18n: 'post-code'}}</div>
                  <div class="table-header-item-chassis-vehicle">{{'' | i18n: 'house-no'}}</div>
                  <div class="table-header-item-chassis-vehicle">{{'' | i18n: 'street'}}</div>
                  <div class="table-header-item-chassis-vehicle">{{'' | i18n: 'location'}}</div>
                  <div class="table-header-item-chassis-vehicle">{{'' | i18n: 'private-phone'}}</div>
                  <div class="table-header-item-chassis-vehicle">{{'' | i18n: 'email'}}</div>
                  <div class="table-header-item-chassis-vehicle">{{'' | i18n: 'action'}}</div>
                </div>
                @if (warranty.owner) {
                  <div class="table-list2">
                    <div class="table-list-item-chassis-vehicle">{{ warranty.owner.company }}</div>
                    <div class="table-list-item-chassis-vehicle">{{ warranty.owner.firstName }}</div>
                    <div class="table-list-item-chassis-vehicle">{{ warranty.owner.lastName }}</div>
                    <div class="table-list-item-chassis-vehicle">{{ warranty.owner.postCode }}</div>
                    <div class="table-list-item-chassis-vehicle">{{ warranty.owner.streetNumber }}</div>
                    <div class="table-list-item-chassis-vehicle">{{ warranty.owner.street }}</div>
                    <div class="table-list-item-chassis-vehicle">{{ warranty.owner.city }}</div>
                    <div class="table-list-item-chassis-vehicle">{{ warranty.owner.telephone }}</div>
                    <div class="table-list-item-chassis-vehicle">{{ warranty.owner.email }}</div>
                    <div class="table-list-item-chassis-vehicle">
                      <button [disabled]="!editable || isYUCAllowed()" (click)="stepToOne()" class="btn-default"
                        style="width: 150px;">{{'' | i18n: 'select-customer'}}<i class="fa fa-chevron-right"
                      aria-hidden="true"></i></button>
                    </div>
                  </div>
                }
                <div class="table-list2"
                style="margin-bottom: 30px; box-sizing: border-box; padding-top: 5px; padding-bottom: 5px; padding-left: 8px;">{{'' | i18n: 'search-vehicle-owner'}} </div>
              </div>
            }
          </div>
        }
      </div>
    }

    @if (step === 1) {
      <div><!-- CUSTOMER DETAILS -->
        <div class="step-title-container">{{'' | i18n: 'step-2-title'}}.</div>
        <div class="form-block-container">
          <h3 style="margin-top: 0;">{{'' | i18n: 'owner-details'}}.</h3>
          <app-customer-details [dealer]="warranty?.contract?.deliveryLocation" [editable]="!isYUCAllowed()"
            [showSearch]="true" #customerOwner [customer]="warranty.owner"
          [dealerOptions]="dealerOptions"></app-customer-details>
          <br>
            @if (!warranty.isExtended) {
              <h3>{{'' | i18n: 'user-details'}}.</h3>
            }
            @if (!warranty.isExtended) {
              <label>{{'' | i18n: 'same-as-owner'}}
                @if (!warranty.isExtended) {
                  <input [disabled]="!editable  || isYUCAllowed()" type="checkbox" id="ownerKeeper"
                    [(ngModel)]="ownerIsUser" (ngModelChange)="mergeOwnerAndUser()">
                }
              </label>
            }
            @if (!warranty.isExtended) {
              <app-customer-details [dealer]="warranty?.contract?.deliveryLocation" [editable]="!isYUCAllowed()"
                [showSearch]="true" #customerUser
              [customer]="warranty.user" [dealerOptions]="dealerOptions"></app-customer-details>
            }
            <br>
              @if (!warranty.isExtended) {
                <h3>{{'' | i18n: 'keeper-details'}}.</h3>
              }
              @if (!warranty.isExtended) {
                <label>{{'' | i18n: 'same-as-owner'}}
                  @if (!warranty.isExtended) {
                    <input [disabled]="!editable  || isYUCAllowed()" type="checkbox" [(ngModel)]="ownerIsKeeper"
                      (ngModelChange)="mergeOwnerAndKeeper()">
                  }
                </label>
              }
              @if (!warranty.isExtended) {
                <app-customer-details [dealer]="warranty?.contract?.deliveryLocation" [editable]="!isYUCAllowed()"
                  [showSearch]="true"
                  #customerKeeper [customer]="warranty.keeper"
                [dealerOptions]="dealerOptions"></app-customer-details>
              }
            </div>
            <div class="customer-submit-row">
              <button id="submit-customer" [disabled]="!editable  || isYUCAllowed()"
              (click)="completeCustomerDetailsAndContinue()">{{'' | i18n: 'continue'}}</button>
            </div>
          </div>
        }
        <br/>

        @if (step === 2) {
          <div><!-- WARRANTY CONTRACT INFORMATION -->
            <div class="step-title-container">{{'' | i18n: 'step-3-title'}}.</div>
            <div class="warranty-row-container" style="display: -webkit-box;">
              @if (!warranty.isExtended) {
                <div class="warranty-main-columns">
                  <h3 style="margin-top: 0;">{{'' | i18n: 'order-date'}}.</h3>
                  <div class="warranty-field-container">
                    <div class="warranty-label">
                      {{'' | i18n: 'order-date'}}*:
                    </div>
                    @if (!showReadOnlyDate) {
                      <div class="warranty-field">
                        <input id="warranty-order-Date" type="date"
                          [disabled]="!editable || isYUCAllowed()"
                          [(ngModel)]="warranty.contract.orderDate"
                 min="{{ getDateDaysFromToday((!isAdmin && saving?.orderDateMaxNumberOfDaysInThePast ? saving.orderDateMaxNumberOfDaysInThePast: 3650) * -1 )
                 | date: 'yyyy-MM-dd' }}"
                          max="{{ getDateDaysFromToday(!isAdmin && saving?.orderDateMaxNumberOfDaysInTheFuture ? saving.orderDateMaxNumberOfDaysInTheFuture: 3650) | date: 'yyyy-MM-dd' }}"
                          (change)="orderDateChanged()">
                        </div>
                      }
                      @if (showReadOnlyDate) {
                        <div class="warranty-field">
                          <input type="date" [disabled]="true" [(ngModel)]="warranty.contract.orderDate">
                        </div>
                      }
                      <div class="warranty-error">
                        {{'' | i18n:orderDateError}}
                      </div>
                    </div>
                    @if (showSalesPrice) {
                      <div class="warranty-field-container">
                        <div class="warranty-label">
                          {{'' | i18n: 'sales-price'}}:
                        </div>
                        <div class="warranty-field">
                          <input type="number" [disabled]="!editable || isYUCAllowed()" [(ngModel)]="warranty.vehicle.salesPrice">
                        </div>
                      </div>
                    }
                  </div>
                }
                <div class="warranty-main-columns">
                  <h3 style="margin-top: 0px;">{{'' | i18n: 'contract-type'}}.</h3>
                  <div class="warranty-field-container">
                    <div class="warranty-label">
                      {{'' | i18n: 'contract-type'}}*:
                    </div>
                    <div class="warranty-field">
                      <label>
                        <select id="warranty-contract-TypeId" style="width: 290px;" [disabled]="!editable || isYUCAllowed()"
                          [(ngModel)]="warranty.contract.contractType" (ngModelChange)="selectContractType()">
                          <option value="null">{{'' | i18n: 'select'}}</option>
                          @for (c of distinctContractTypes(); track c) {
                            <option [ngValue]="c.contractType" >{{ c.contractType }}</option>
                          }
                          @if (warranty.contract.contractType === 'MINI NEXT YUC') {
                            <option>{{"MINI NEXT YUC"}}</option>
                          }
                        </select>
                      </label>
                    </div>
                    <div class="warranty-error">
                      {{contractTypeError}}
                    </div>
                  </div>
                  <div class="warranty-field-container">
                    <div class="warranty-label">
                      {{'' | i18n: 'contract-duration'}}*:
                    </div>
                    <div class="warranty-field">
                      <label style="width: 95%;">
                        @if (selectedContractType) {
                          <select style="width: 290px;" id="warranty-contract-DurationId"
                            [disabled]="!editable || isYUCAllowed()" [(ngModel)]="warranty.contract.contractCode">
                            <option value="null">{{'' | i18n: 'select'}}</option>
                            @for (c of selectedContractType.contractCodes; track c) {
                              <option
                              value="{{c.code}}">{{c.period + ' Months'}}</option>
                            }
                          </select>
                        }
                        @if (!selectedContractType) {
                          <select [disabled]="!editable || isYUCAllowed()" id="warranty-contract-Duration">
                            <option value="null">{{'' | i18n: 'select'}}</option>
                          </select>
                        }
                      </label>
                    </div>
                    <div class="warranty-error">
                      {{contractDurationError}}
                    </div>
                  </div>
                </div>
                @if (warranty.isExtended) {
                  <div class="warranty-main-columns">
                    <h3 style="margin-top: 0px;">{{'' | i18n: 'selling-dealer'}}:</h3>
                    <div class="warranty-label">
                      {{'' | i18n: 'selling-dealer'}}*:
                    </div>
                    <div class="warranty-field">.
                      <select [(ngModel)]="sellingDealer" [disabled]="!editable || isYUCAllowed()" (ngModelChange)="deliveryLocationChanged()">
                        <option value="null">{{'' | i18n: 'select'}}</option>
                        @for (dealer of dealerOptions; track dealer) {
                          <option [ngValue]="dealer">{{dealer.dealerName}}</option>
                        }
                      </select>
                    </div>
                    <div class="warranty-error">
                      {{sellingDealerError}}
                    </div>
                  </div>
                }
                @if (!warranty.isExtended) {
                  <div class="warranty-main-columns">
                    <h3 style="margin-top: 0px;">{{'' | i18n: 'delivery-date'}}.</h3>
                    <div class="warranty-field-container">
                      <div class="warranty-label">
                        {{'' | i18n: 'delivery-date'}}*:
                      </div>
                      <div class="warranty-field">
                        <input id="warranty-delivery-Date" type="date"
                          [disabled]="!editable || isYUCAllowed()"
                 min="{{ getDateDaysFromToday((!isAdmin && saving?.deliveryDateMaxNumberOfDaysInThePast? saving.deliveryDateMaxNumberOfDaysInThePast: 3650  ) * -1)
                 | date: 'yyyy-MM-dd' }}"
                 max="{{ getDateDaysFromToday(!isAdmin && saving?.deliveryDateMaxNumberOfDaysInTheFuture? saving.deliveryDateMaxNumberOfDaysInTheFuture: 3650)
                 | date: 'yyyy-MM-dd' }}"
                          [(ngModel)]="warranty.contract.deliveryDate">
                        </div>
                        <div class="warranty-error">
                          {{'' | i18n: deliveryDateError }}
                        </div>
                      </div>
                      <div class="warranty-label">
                        {{'' | i18n: 'selling-dealer'}}*:
                      </div>
                      <div class="warranty-field" [hidden]="warranty.contract.contractType==='MINI NEXT YUC'">
                        <select [(ngModel)]="sellingDealer" [disabled]="!editable || isYUCAllowed()" (ngModelChange)="deliveryLocationChanged()">
                          <option value="null">{{'' | i18n: 'select'}}</option>
                          @for (dealer of dealerOptions; track dealer) {
                            <option [ngValue]="dealer">{{dealer.dealerName}}</option>
                          }
                        </select>
                      </div>
                      <div class="warranty-error">
                      </div>
                      @if (warranty.contract.contractType==='MINI NEXT YUC') {
                        <div >
                          <input  id="selling-dealer" type="text"
                            [disabled]="!editable || isYUCAllowed()"
                            [value]="beluxDealer"
                            />
                            <div class="warranty-label">
                              {{'' | i18n: 'delivering-agent'}}*:
                            </div>
                            <div class="warranty-field">
                              <select [disabled]="!editable || isYUCAllowed()" [(ngModel)]="sellingDealer" required (ngModelChange)="deliveryLocationChanged()" >
                                <option value="null">{{'' | i18n: 'select'}}</option>
                                @for (d of dealerOptions; track d) {
                                  <option [ngValue]="d" >{{d.dealerName}}</option>
                                }
                              </select>
                            </div>
                            <div class="warranty-error">
                              {{'' | i18n: deliveringAgentError }}
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @if (!warranty.isExtended) {
                      <div class="warranty-main-columns">
                        <h3 style="margin-top: 0px;">{{'' | i18n: 'delivery-mileage'}}.</h3>
                        <div class="warranty-field-container">
                          <div class="warranty-label">
                            {{'' | i18n: 'delivery-mileage'}}*:
                          </div>
                          <div class="warranty-field">
                            <input id="warranty-delivery-mileage" type="text"
                              [disabled]="!editable || isYUCAllowed()"
                              [(ngModel)]="warranty.contract.deliveryMileage">
                            </div>
                            <div class="warranty-error">
                              {{'' | i18n: deliveryMileageError }}
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="customer-submit-row">
                      <button class="submit-warranty-cancel" id="submit-warranty-cancel" [disabled]="!editable || isYUCAllowed()"
                      (click)="goBack()">{{'' | i18n: 'cancel'}}</button>
                      <button class="submit-warranty-info" id="submit-warranty-info" [disabled]="!editable || isYUCAllowed()"
                      (click)="stepToThree()">{{'' | i18n: 'save-continue'}}</button>
                    </div>
                  </div>
                }

                @if (step === 3) {
                  <div id="acceptance-criteria"><!-- ACCEPTANCE CRITERIA -->
                    <div class="step-title-container">{{'' | i18n: 'step-4-title'}}</div>
                    <div class="form-block-container">
                      <div class="maintenance-row">
                        <div class="maintenance-label">
                          @if (!isNL()) {
                            <div>
                              {{question1}}
                            </div>
                          }
                          @if (isNL()) {
                            <div>
                              <div>
                                {{'' | i18n: 'oil-change-question'}}
                              </div>
                              <div class="pb-sm-2">
                                <a (click)="downloadPdf('Toelatingseisen BMW Premium Selection MINI Occasions NEXT')">
                                  <i class="fa fa-file-pdf-o" aria-hidden="true"></i>{{'' | i18n: 'download'}}
                                </a>
                              </div>
                            </div>
                          }
                        </div>
                        <div class="maintenance-action">
                          <div class="maintenance-action-txt">{{'' | i18n: 'no'}}</div>
                          <label class="switch">
                            @if (warranty.contract) {
                              <input type="checkbox" id="warranty-oilChangesTimely" [disabled]="!editable || isYUCAllowed()"
                                [(ngModel)]="warranty.contract.oilChangesTimely">
                            }
                            <span class="slider round"></span>
                          </label>
                          <div class="maintenance-action-txt" style="padding-left: 20px;">{{'' | i18n: 'yes'}}</div>
                        </div>
                        @if (warranty.contract?.contractCode != '12BSUP' && warranty.contract?.contractCode != '12MSUP') {
                          <div
                            class="maintenance-label">
                            @if (!isNL()) {
                              <div>
                                {{question2}}
                              </div>
                            }
                            @if (isNL()) {
                              <div>
                                {{'' | i18n: 'pass-360-question'}}
                              </div>
                            }
                          </div>
                        }
                        @if (warranty.contract?.contractCode != '12BSUP' && warranty.contract?.contractCode != '12MSUP') {
                          <div
                            class="maintenance-action">
                            <div class="maintenance-action-txt">{{'' | i18n: 'no'}}</div>
                            <label class="switch">
                              @if (warranty?.contract) {
                                <input type="checkbox" id="warranty-passed360" [disabled]="!editable || isYUCAllowed()"
                                  [(ngModel)]="warranty.contract.passed360">
                              }
                              <span class="slider round"></span>
                            </label>
                            <div class="maintenance-action-txt" style="padding-left: 20px;">{{'' | i18n: 'yes'}}</div>
                          </div>
                        }
                      </div>
                      @if (!warranty.contract?.oilChangesTimely || !warranty.contract?.passed360) {
                        <div style="text-align: center; font-size: 14px" class="error-text-small"
                        >{{'' | i18n: 'accept-error'}}</div>
                      }
                    </div>
                    <br/>
                    @if (!adminCreatingNewWarranty()) {
                      <div class="step-title-container">{{'' | i18n: 'special-request'}}</div>
                    }
                    <div class="step-title-container"></div>
                    @if (!adminCreatingNewWarranty()) {
                      <div class="form-block-container">
                        <app-switch [on]="warranty.specialRequestRequested"
                          [question]="'have-you-got-a-special-request'"
                          [disabled]="!editable || isYUCAllowed()"
                        (value)="specialRequestRequired($event)"></app-switch>
                      </div>
                    }
                    @if (displaySpecialRequest) {
                      <div class="form-block-container">
                        {{''| i18n:'special-request-terms-and-conditions'}}
                      </div>
                    }
                    @if (displaySpecialRequest && !isAdmin) {
                      <app-special-request
                        [includeEuroPlusFields]="selectedContractType ? !selectedContractType?.used : !warranty?.contract?.used"
                        class="form-block-container"
                        [disabled]="!editable || isYUCAllowed() || isSpecialRequestAllowed()"
                      (specialRequestEmitter)="onSpecialRequest($event)"></app-special-request>
                    }
                    @if (warranty.specialRequestRequested && !displaySpecialRequest) {
                      <app-special-request-item class="form-block-container" style="width: 90%;margin-left: 5%; margin-right: 0;"
                        [specialRequest]="warranty.specialRequest"
                      ></app-special-request-item>
                    }
                    @if (showDealerCorrectionReviews()) {
                      <app-dealer-correction-review
                        class="form-block-container"
                        [specialRequestId]="warranty?.specialRequest?.id"
                        [warrantyId]="warranty?.id"
                        [warrantyStatus]="this.warranty?.warrantyStatus"
                        [messages]="messages" #dealerCorrectionReview
                      ></app-dealer-correction-review>
                    }
                    @if (isAdmin) {
                      <section>
                        @if (isAdmin) {
                          <div class="step-title-container">{{'' | i18n: 'admin-notes'}}</div>
                        }
                        @if (isAdmin) {
                          <div class="step-title-container"></div>
                        }
                        @if (isAdmin) {
                          <div class="form-block-container">
                            <textarea maxlength="500" [(ngModel)]="warranty.adminNotes"></textarea>
                          </div>
                        }
                      </section>
                    }
                    @if (displayPreviousAgContract()) {
                      <section id="previousAgContract"
                        >
                        <div class="step-title-container">{{''|i18n:'previous-ag-contracts'}}</div>
                        <app-previous-ag-contract class="form-block-container"
                        (previousAgContract)="onPreviousAgContract($event)"></app-previous-ag-contract>
                      </section>
                    }
                    @if (displayPremiumCalculation()) {
                      <div class="step-title-container"> {{''|i18n:'premium-calculation'}}</div>
                    }
                    @if (displayPremiumCalculation()) {
                      <app-premium-calculation [contractCode]="warranty.contract.contractCode"
                        [deliveryDate]="warranty.contract.deliveryDate"
                        [calculatedRate]="warranty.contract.contractRate"
                        (atPremiumCalculation)="onPremiumCalculation($event)"
                      class="form-block-container"></app-premium-calculation>
                    }
                    <div class="customer-submit-row">
                      @if (!specialRequestActionable()) {
                        <button id="submit-criteria" style=" padding: 11px;height: 46px;" (click)="stepToFour()"
                        [disabled]="!proceedToStep4Eligible() || isYUCAllowed() || isSpecialRequestAllowed()">{{'' | i18n: 'save-continue'}}</button>
                      }
                      @if (warranty.warrantyStatus === 'In Review') {
                        <button id="cancel" class="submit-warranty-cancel"
                          style=" padding: 11px;height: 46px;"
                        (click)="goBack()">{{''|i18n:'cancel'}}</button>
                      }
                      @if (specialRequestActionable()) {
                        <button id="declineSpecialRequest" style=" padding: 11px;height: 46px;"
                        (click)="declineSpecialRequest()">{{'' | i18n: 'decline'}}</button>
                      }
                      @if (displayPremiumCalculation()) {
                        <button id="approve" (click)="approve()"
                          [disabled]="approvalIneligible()"
                        style=" padding: 11px;height: 46px;">{{''| i18n:'approve'}}</button>
                      }
                      @if (displayOpenContract()) {
                        <button (click)="openContract()" id="open-contract"
                        style=" padding: 11px;height: 46px;">{{''| i18n:'open-contract'}}</button>
                      }
                    </div>
                  </div>
                }


                @if (step === 4) {
                  <div><!-- SUMMARY -->
                    @if (warranty.warrantyStatus) {
                      <div>
                        <div class="step-title-container">{{'' | i18n: 'step-5-title'}}</div>
                        <div class="form-block-container">
                          <app-warranty-summary [dealers]="dealerOptions" [editable]="editable" [warranty]="warranty"
                            [question1]="question1"
                            [question2]="question2"
                            [creditNote]="creditNote"
                            [hasCreditNote]="hasCreditNote">
                          </app-warranty-summary>
                        </div>
                        <div class="customer-submit-row">
                          @if (warranty.id && warranty.warrantyStatus !== 'Cancelled') {
                            <button [hidden]="isYUCAllowed()"
                            (click)="onCancel()">{{'' | i18n: 'abort-warranty'}}</button>
                          }
                          @if (warranty.id) {
                            <button (click)="goBack()">{{'' | i18n: 'back-to-dashboard'}}</button>
                          }
                          @if (warranty.warrantyStatus==='In Progress' || (isAdmin && warranty.warrantyStatus === 'In Review' && approvalInProgress)) {
                            <button
                              id="submit-summary" (click)="openModal()"
                            [disabled]="!submissionEnabled() || isYUCAllowed()">{{'' | i18n: 'submit-warranty'}}</button>
                          }
                          @if (displayPrintButtons()) {
                            <button
                            (click)="printCertificate(warranty.warrantyNumber)">{{'' | i18n: 'print-warranty'}}</button>
                          }
                        </div>
                      </div>
                    }
                    @if (warranty.warrantyStatus === 'Declined') {
                      <section class="step-title-container">
                        <div style="margin-bottom: 37px;">
                          {{''|i18n:'contract-feedback'}}
                        </div>
                        <div>
                          <app-special-request-item [specialRequest]="warranty.specialRequest"></app-special-request-item>
                        </div>
                        <div class="customer-submit-row">
                          <button class="submit-warranty-cancel" (click)="goBack()">{{''| i18n:'close'}}</button>
                        </div>
                      </section>
                    }
                  </div>
                }
